import {html} from 'lit-element';
import Types from '@camtv/front-base-lib/utilities/types';
import CtvLitElementBase from './element-base';

import '@camtv/front-base-css/main/_colors.scss';
import "./button.scss";

/**
 * litElement for camtv form buttons
 * @module CtvButton
 * @property {String|HTMLString}  	label					- set button label
 * @property {String}  				[status="active"]		- set button status [active, sending, error, disabled, semiactive, success]
 * @property {String}  				[format="plain"]		- set button format [plain, outline]
 * @property {String}  				[size="normal"]			- set butotn size [normal, medium, big]
 * @property {String|HTMLString}  	[error_msg]    			- set error message in case of call failure
 */
export default class CtvButton extends CtvLitElementBase {

	static get DomTag() { return  'ctv-button'; }

	//Add translations
	GetTranslations() {
		return {
			"Invia": {
				"it": "Invia",
				"en": "Send"
			}
		}
	}

	static get properties() {
		return {
			label: {type: String},
			status: {type: String},
			format: {type: String},
			size: {type: String},
			error_msg: {type: String}
		};
	}

	static get STATUS() {
		return {
			ACTIVE: "active",
			SENDING: "sending",
			ERROR: "error",
			SUCCESS: "success",
			DISABLED: "disabled",
			SEMIACTIVE: "semiactive",
		}
	}

	static get SIZES() {
		return {
			NORMAL: "normal",
			MEDIUM: "medium",
			BIG: "big"
		}
	}

	static get FORMATS() {
		return {
			PLAIN: "plain",
			OUTLINE: "outline"
		}
	}
	
	constructor() {
		super();
		this.label = "";
		this.status = CtvButton.STATUS.ACTIVE;
		this.size = CtvButton.SIZES.NORMAL;
		this.format = CtvButton.FORMATS.PLAIN;
		this.error_msg = "";

		this.button_id = "CTV_BUTTON_" + Math.floor(Math.random() * 100) + 1;
	}

	/**
     * Access directly to the button DOM element
     * @method button
	 * @returns {element}
     */
	get button() {
		return this.querySelector("button");
	}

	createRenderRoot() {
		return this;
	}
	
	render() {
		return html`                   
			<button
				class="${this.status} ${this.format} ${this.size}"
				id="${this.button_id}"
			>${this.RenderText()}</button>`;
	}

	updated(changedproperties) {
		super.updated(changedproperties);
	}

	RenderText() {
		let text = this.label != "" ? this.label : this.Ln("Invia");

		if(this.status == CtvButton.STATUS.ERROR && this.error_msg != "")
			text = this.error_msg;
		else if(this.status == CtvButton.STATUS.SENDING)
			text = "<span></span><span></span><span></span>";

		return html`${this.ToHtml(text)}`;
	}
	
}

CtvButton.RegisterElement();